<app-modal>
  <app-modal-header
    *ngIf="!loading"
    [title]="T.reports.pdf_export_report | translate"
    [showDelete]="false"
    (closed)="confirmClose()"
  ></app-modal-header>
  <app-modal-body *ngIf="!loading">
    <div class="save-report-body" [formGroup]="form">
      <div class="save-report-body-instruction">
        {{ T.reports.give_your_exported_report_title | translate }}
      </div>
      <div class="save-report-body-title">
        <app-text-field
          [displayError]="triggerErrors"
          formControlName="reportTitle"
          [maxLength]="80"
          [minlength]="3"
          [autofocus]="true"
          [required]="true"
          [disabled]="loading"
          [placeholder]="(T.defaultLocalizations.title.one | translate) + '*'"
          [formGroup]="form"
          [useReactiveMessages]="true">
        </app-text-field>
      </div>
      <div class="save-report-body-description">
        <app-text-area
          [placeholder]="T.defaultLocalizations.description.one | translate"
          formControlName="reportDescription"
          [maxLength]="250"
          [minlength]="0"
          [formGroup]="form"
          [rows]="5"
          [disabled]="loading"
          [required]="false"
        ></app-text-area>
      </div>
      <div class="export-pdf-info-container">
        <div class="export-pdf-info-icon"><i class="material-symbols-outlined">info</i></div>
        <div class="export-pdf-info-text">{{ T.common.go_to | translate }} <span style="font-weight: bold;">{{ T.settings.document_manager | translate }}</span> {{ T.reports.see_reports_in_document_manager | translate }}</div>
      </div>
    </div>
  </app-modal-body>
  <app-modal-footer *ngIf="!loading">
    <div class="save-report-footer">
      <app-button-rectangle
        class="mr-8"
        [text]="T.common.cancel | translate"
        [buttonTheme]="'white'"
        [size]="'large'"
        [loading]="loading"
        (clicked)="confirmClose()"
      ></app-button-rectangle>
      <app-button-rectangle
        [text]="T.common.save | translate"
        [size]="'large'"
        [disabled]="form.invalid"
        [loading]="loading"
        (clicked)="onApply()"
      ></app-button-rectangle>
    </div>
  </app-modal-footer>
  <app-loading *ngIf="loading">
    <p>{{ T.common.loading | translate }}...</p>
  </app-loading>
</app-modal>
